import React from 'react';
import { Container } from '@mui/material';
import EventsForm from './EventForm/EventFormMain';

const CreateEventAdmin: React.FC = () => {
    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <EventsForm createNewEvent={true} configuratorMode={false} />
        </Container>
    );
};

export default CreateEventAdmin;